angular.module('dpw.directives')
    .directive('urlValidator', ['validatePattern', function (validatePattern) {
        return {
            require: 'ngModel',
            link: function (scope, elm, attrs, ctrl) {
                var httpsPattern = validatePattern.https;
                var urlPattern = validatePattern.url;

                ctrl.$validators.url = function (modelValue, viewValue) {
                    if (ctrl.$isEmpty(modelValue)) {
                        return true;
                    }

                    return isUrl(viewValue);
                };

                ctrl.$validators.https = function (modelValue, viewValue) {
                    if (ctrl.$isEmpty(modelValue) || !isUrl(modelValue)) {
                        return true;
                    }
                    return httpsPattern.test(viewValue);
                };

                function isUrl(value) {
                    return urlPattern.test(value);
                }
            }
        };
    }]);
